import React from 'react';
import QueryWidget from '@plone/volto/components/manage/Widgets/QueryWidget';
import QuerystringWidget from '@plone/volto/components/manage/Widgets/QuerystringWidget';

interface QueryFieldWidgetProps {
  value?: unknown;
  behavior?: string;
  [key: string]: unknown;
}

/**
 * Dois campos diferentes se chamam `query` no portal, e o Volto escolhe o
 * widget pelo **id** do campo antes de olhar qualquer outra coisa
 * (`getWidgetByFieldId` é o primeiro da cadeia em `Form/Field.jsx`), então
 * os dois caíam no mesmo `QuerystringWidget`:
 *
 * - **Bloco de Busca**: valor é um objeto — `{query: [...], sort_on,
 *   b_size, ...}`. É o que o `QuerystringWidget` espera (ele lê
 *   `props.value?.query`).
 * - **Collection** (campo `query` do behavior `plone.collection`): valor é
 *   uma lista pura de critérios — `[{i, o, v}, ...]`. Nesse formato o
 *   `QuerystringWidget` não acha `value.query`, e o formulário de edição
 *   abria com "Critérios" vazio mesmo com a Collection tendo critérios
 *   salvos — com o risco de sobrescrever a query ao salvar.
 *
 * `QueryWidget` é exatamente o editor de lista de critérios
 * (`value: PropTypes.array`) e é autossuficiente: se conecta sozinho a
 * `state.querystring` e busca os índices disponíveis.
 */
const QueryFieldWidget: React.FC<QueryFieldWidgetProps> = (props) => {
  const isCollectionQuery =
    props.behavior === 'plone.collection' || Array.isArray(props.value);

  const Widget = isCollectionQuery ? QueryWidget : QuerystringWidget;

  return <Widget {...(props as any)} />;
};

export default QueryFieldWidget;
